<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <form>
        <h4><b>Update Business</b></h4>
        <md-field>
          <label for="name">Business Name</label>
          <md-input
            v-model="form.name"
            placeholder="Enter Business Name"
            id="name"
          ></md-input>
        </md-field>
        <md-field>
          <label for="email">Email</label>
          <md-input
            v-model="form.email"
            placeholder="Enter Email"
            id="email"
          ></md-input>
        </md-field>
        <md-field>
          <label>Phone Number</label>
          <md-input
            v-model="form.phone"
            placeholder="Enter Phone Number"
            id="phone"
          ></md-input>
        </md-field>

        <md-button class="md-primary md-raised" @click="updateBusiness()"
          >Update Business</md-button
        >
      </form>
    </div>
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import http from '../../utils/Http.util';

export default {
  data() {
    return {
      activeBusiness: this.$store.state.activeBusiness || '',
      form: {
        name: this.$store.state.activeBusiness.name || '',
        email: this.$store.state.activeBusiness.email || '',
        phone: this.$store.state.activeBusiness.phone || '',
      },
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    async updateBusiness() {
      try {
        if (!this.form.name || !this.form.email || !this.form.phone) {
          this.snackBar = {
            show: true,
            message: 'Please enter all fields before proceeding',
          };
          return;
        }
        this.$store.commit('busyStatus', true);
        const { id } = this.activeBusiness;
        const { message } = await http.authReq(
          `/dashboard/business/update/${id}`,
          {
            ...this.form,
          },
          'post',
        );
        await this.getActiveBusiness();

        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message,
        };
      } catch (error) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
    },
    async getActiveBusiness() {
      // this.$store.commit("busyStatus", true);
      try {
        const result = await http.authReq('/dashboard/business-access/active');
        const { data } = result;

        this.$store.commit('setActiveBusiness', data.business.business);
        // this.$store.commit("busyStatus", false);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: 'Unable to get active business',
        };
        // this.$store.commit("busyStatus", false);
      }
    },
  },
};
</script>

<style scoped>
.md-card-header {
  background: transparent !important;
  font-weight: 500;
}
</style>
